<template>
  <layout>
    <page-header header="Create user" />
    <div class="content">
      <resource-form @saved="returnBack" @cancelled="returnBack" />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'users'

export default {
  name: 'UsersCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
